import React from "react";
import PropTypes from "prop-types";
import { Plus } from "lucide-react";
import FloatingLabelInput from "../forms/FloatingLabelInput";
import PromoCodes from "./PromoCodes";
import "./PromoCommentForm.scss";

const PromoCodeField = ({
  promoCode,
  setPromoCode,
  isSubmitting,
  promoError,
  handleApplyPromoCode,
  simplifiedVersion = false,
  submittedPromoCodes = [],
}) => {
  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      await handleApplyPromoCode();
    }
  };


  return (
    <div className="input-group w-full">
      {!simplifiedVersion ? (
        <div className="w-full flex flex-col gap-1">
          <label className="input-label">Apply Promo Code:</label>
          <div className="input-wrapper flex flex-row justify-between gap-5 items-center">
            <input
              type="text"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              placeholder="Enter Promo Code"
              className="input-field"
              disabled={isSubmitting}
              onKeyDown={handleKeyDown}
            />
            <button
              className="apply-coupon-btn"
              onClick={() => handleApplyPromoCode(String(promoCode))}
              disabled={isSubmitting}
              type="button"
            >
              <Plus size={18} />
              Add
            </button>
          </div>
          {promoError && (
            <div className="text-red-500 text-sm mt-1">{promoError}</div>
          )}
        </div>
      ) : (
        <div className="w-full flex flex-col gap-1 relative">
          <div className="flex items-start gap-3 w-full">
            <div className="w-full">
              <FloatingLabelInput
                label="Enter Promo Code"
                name="promoCode"
                type="text"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={isSubmitting}
              />
            </div>
            <button
              className={`apply-coupon-btn ${simplifiedVersion ? "simplified" : ""}`}
              onClick={() => handleApplyPromoCode(String(promoCode))}
              disabled={isSubmitting}
              type="button"
            >
              Apply
            </button>
          </div>
          {promoError && (
            <div className="text-red-500 text-sm mt-1">{promoError}</div>
          )}
        </div>
      )}

      {submittedPromoCodes?.length > 0 && (
        <div className="mt-4">
          <PromoCodes promoCodes={submittedPromoCodes} />
        </div>
      )}
    </div>
  );
};

PromoCodeField.propTypes = {
  promoCode: PropTypes.string,
  setPromoCode: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  promoError: PropTypes.string,
  handleApplyPromoCode: PropTypes.func.isRequired,
  simplifiedVersion: PropTypes.bool,
  submittedPromoCodes: PropTypes.array
};

export default PromoCodeField;
